<template>


<!-- <v-tabs
                        v-model="tab"
                        bg-colo r="primary"
                      >-->
      <!-- <v-tab value="0" >{{$t('pestana_configuracion_general.tab_curvas')}}</v-tab>
      <v-tab value="2" >{{$t('pestana_configuracion_general.tab_electrolizador')}}</v-tab>
      <v-tab value="1" >{{$t('pestana_configuracion_general.tab_coste')}}</v-tab> -->
<!--       <v-tab value="3" >{{$t('pestana_configuracion_general.simulacion')}}</v-tab>
      

    </v-tabs>
    <v-tabs-window v-model="tab">       -->        
<!-- 
      <v-tabs-window-item value="0">
          <ComponenteConfiguracion :disabled="this.id" :caso_base="this.caso_base" v-model:curvas="curvas"    />
      </v-tabs-window-item>

      <v-tabs-window-item value="1">
          <ComponenteCostes :disabled="this.id" :caso_base="this.caso_base"  v-model:costes="costes"/>
      </v-tabs-window-item>

      <v-tabs-window-item value="2">
          <ComponenteInputElectrolizadorRend :disabled="this.id" :caso_base="this.caso_base"  v-model:value="curvas_rend"/>
      </v-tabs-window-item> -->
      <!-- <v-tabs-window-item value="3">
          <ComponenteSimulacion :caso_base="this.caso_base"/>
      </v-tabs-window-item>
    </v-tabs-window> -->
    <ComponenteSimulacion :caso_base="this.caso_base"/>
</template>

<script>
/* import ComponenteConfiguracion from '../components/ComponenteConfiguracion.vue';
import ComponenteCostes from './ComponenteCostes.vue';

import ComponenteInputElectrolizadorRend from './ComponenteInputElectrolizadorRend.vue'; */
import ComponenteSimulacion from './ComponenteSimulacion.vue';
export default{
    props: {

    },
  components: { 

/*       ComponenteConfiguracion,
      ComponenteCostes,
      ComponenteInputElectrolizadorRend, */
      ComponenteSimulacion

      },
  data() {
    return{
        curvas:[],
        costes:[],
        curvas_rend:[],

        tab:"3",
        caso_base:true,
    }

  },
}

</script>